import { useMemo } from 'react'
import PropTypes from 'prop-types'
import ReactECharts from 'echarts-for-react'

/**
 * InfrastructureStatusChart (Bare) - Chart only, no wrapper
 * For embedding in narrative HTML templates
 */
function InfrastructureStatusChart({ data }) {
  const chartData = useMemo(() => {
    if (!data || typeof data !== 'object') return []

    const categories = [
      { key: 'electricity', name: 'Electricity', color: '#3B82F6' },
      { key: 'water', name: 'Water Supply', color: '#10B981' },
      { key: 'ictLab', name: 'ICT Laboratory', color: '#F59E0B' },
      { key: 'handwashing', name: 'Handwashing', color: '#06B6D4' },
      {
        key: 'genderToilets',
        name: 'Gender-Separated Toilets',
        color: '#8B5CF6',
      },
      {
        key: 'accessibleToilets',
        name: 'Accessible Toilets',
        color: '#EC4899',
      },
    ]

    return categories
      .map(cat => ({
        name: cat.name,
        value: data[cat.key] || 0,
        color: cat.color,
        key: cat.key,
      }))
      .sort((a, b) => b.value - a.value)
  }, [data])

  const barOptions = useMemo(
    () => ({
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        formatter: params => {
          const param = params[0]
          return `<strong>${param.name}</strong><br/>${param.value}% of schools`
        },
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
      },
      xAxis: {
        type: 'value',
        max: 100,
        axisLabel: {
          formatter: '{value}%',
        },
      },
      yAxis: {
        type: 'category',
        data: chartData.map(item => item.name),
        axisLabel: {
          fontSize: 11,
        },
      },
      series: [
        {
          name: 'Coverage',
          type: 'bar',
          data: chartData.map(item => ({
            value: item.value,
            itemStyle: {
              color: item.color,
            },
          })),
          label: {
            show: true,
            position: 'right',
            formatter: '{c}%',
            fontSize: 11,
          },
          barMaxWidth: 40,
        },
      ],
    }),
    [chartData]
  )

  if (!data || chartData.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        No infrastructure data available
      </div>
    )
  }

  return <ReactECharts option={barOptions} style={{ height: '350px' }} />
}

InfrastructureStatusChart.propTypes = {
  data: PropTypes.objectOf(PropTypes.number),
}

export default InfrastructureStatusChart
